import type { GraphQLError } from 'graphql';
import { ApolloError } from '@apollo/client/errors';

export function hasGraphQLErrorCode(error: unknown, code: string): boolean {
  if (error instanceof ApolloError) {
    return error.graphQLErrors.some(
      (graphQLError) => graphQLError.extensions?.code === code
    );
  }

  if (Array.isArray(error)) {
    return error.some(
      (graphQLError: GraphQLError) => graphQLError.extensions?.code === code
    );
  }

  return false;
}
